// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//导入使用Element组件及相应css
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css'
import { Loading } from 'element-ui';
import config from '@/config.js'

import Pagination from "@/components/Pagination";
// 全局组件挂载 
Vue.component('Pagination', Pagination)

//导入使用vue-resource通信组件
import VueResource from "vue-resource";
Vue.use(VueResource);

// 配置http请求拦截器，允许提交cookies

// //配置http请求拦截器，允许提交cookies
// Vue.http.interceptors.push(function (request, next) {//拦截器
//   // 跨域携带cookie
//   request.crossDomain = true, 
//   request.credentials = true;
//   next()
// })

// axios方式配置携带cookie
import axios from 'axios'
axios.defaults.withCredentials=true;

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//配置所有路由跳转完毕，关闭顶部加载进度条
router.afterEach(() => {
  NProgress.done()
})

//全局登记状态，目标用sessionID状态替代
Vue.prototype.LoginState;
Vue.prototype.LoginErrNum = 3;
//白名单配置
const whiteList = ['/login', '/auth-redirect', '/bind', '/register']

//所有跳转前，先做登陆判断，登陆的才能跳转，未登陆的跳转去登陆
import {checkLoginAction} from '@/api/login.js'

setInterval(function(){checkLoginAction({token:sessionStorage.getItem("token")+Math.random()}).then(response =>{
  if(response.data===null){
    if(Vue.prototype.LoginState)
    alert("已过期，请重新登陆!");
    //Vue.$alert("已过期，请重新登陆！", "错误信息", { type: "error" });
    Vue.prototype.LoginState = false;
    router.push({ path: "/login" });
  }else{
    //Vue.prototype.LoginState = true;
  }
})},50000);

const Vm = Vue;
router.beforeEach((to, from, next) => {
  NProgress.start() //跳转开启进度条
  if((!sessionStorage.getItem("token")) && to.path !=="/login"){
    // console.log(Vue.prototype.LoginState)
    next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页，并携带定向页
    NProgress.done() //完成关闭进度条
    return;
  }
  if(to.path !=="/login"){
    if(Vue.prototype.LoginState){
      next();
      NProgress.done() //完成关闭进度条
    }else{
      if(Vue.prototype.LoginState == undefined){//页面刷新导致值丢失，所以需要处理下
        checkLoginAction({}).then(response => {
        if(response.data === null){
          next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页，并携带定向页
          NProgress.done() //完成关闭进度条
        }else{
          Vue.prototype.LoginState = true;
          next();
          NProgress.done() //完成关闭进度条
        }
        }).catch(response => Vm.$alert(response.body.Message, "错误信息", { type: "error" }));
      }
    }
  }else{
    next();
    NProgress.done()
  }
})

//增加全局页面参数设置功能
Vue.prototype.getPageParams = function(path){
  return JSON.parse(sessionStorage.getItem(path));
 };
 //增加全局页面参数获得功能
 Vue.prototype.setPageParams = function(path,value){
   sessionStorage.removeItem(path);
   sessionStorage.setItem(path,JSON.stringify(value));
 }

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js